<div class="your-assortment">
  <div class="divider" fxHide fxHide.mm-desktop="false"></div>
  <a [href]="assortmentLink"
    class="your-assortment-button"
    [mmTestTarget]="'navigation-your-assortment-list'" type="button" (click)="hideMenuAndSendGAYourAssortmentEvent()">
    {{ 'HEADER.ALL_PAGES.YOUR_ASSORTMENT_BUTTON' | translate }}
  </a>
</div>